import { JSX, useState } from 'react'
import { useNavigate } from 'react-router'

import { Button, Text } from '@chakra-ui/react'

import { RxPlus } from 'react-icons/rx'


// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Layout from '@/components/layout.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Drawer from '@/components/ui/drawer.tsx'

// eslint-disable-next-line @typescript-eslint/naming-convention
import Loader from './components/loader.tsx'
import update from './components/update.tsx'




// eslint-disable-next-line @typescript-eslint/naming-convention
export function Toolbar
(
	props: {
		search(v: string): void

	},

)
:	JSX.Element
{
	let [keyword, update_keyword] = useState('')

	let on_enter = (): void =>
	{
		props.search(keyword)

	}

	let on_filter = (): void =>
	{
		Drawer.open(
			<></>,

			{ size: 'sm', title: '筛选' },

		)

	}

	let on_create = (): void =>
	{
		Drawer.open(
			<></>,

			{ size: 'lg', title: '添加项目' },

		)

	}

	return (
		<>
			<Layout.Search placeholder="请输入项目名称/项目编号" value={keyword} change={update_keyword} enter={on_enter} />

			<Layout.Filter open={on_filter}>
				<Button colorPalette="blue" rounded="md" onClick={on_create}>
					<RxPlus />
					<Text>添加项目</Text>
				</Button>
			</Layout.Filter>

		</>

	)


}

export default function (): JSX.Element
{
	let navigate = useNavigate()

	let [keyword, update_keyword] = useState('')


	let on_view = (_id: string): void =>
	{
		// eslint-disable-next-line @typescript-eslint/no-floating-promises
		navigate(`./${_id}`)

	}

	let on_update = (_id: string): void =>
	{
		update(_id)

	}

	return (
		<>
			<Layout.Toolbar>
				<Toolbar search={update_keyword} />

			</Layout.Toolbar>

			<Layout.Scroll>
				<Loader keyword={keyword} view={on_view} update={on_update} />

			</Layout.Scroll>

		</>

	)

}
